<div class="iu-wrapper bg-white dark:bg-surface-800 border border-gray-200 dark:border-gray-700" [class.disabled]="disabled">
  <div class="iu-head">
    <div class="iu-head-left">
      <h4 class="iu-title text-gray-800 dark:text-gray-100">{{ label }}</h4>
      @if (hint) { <span class="iu-hint text-surface-500 dark:text-surface-400">{{ hint }}</span> }
    </div>
    @if (remaining()>=0) { <div class="iu-counter bg-gray-100 dark:bg-surface-900 border border-gray-200 dark:border-gray-700 text-gray-700 dark:text-gray-200">{{ images().length }}/{{ maxFiles }}</div> }
  </div>

  <div class="iu-drop border-gray-300 dark:border-gray-600 bg-white dark:bg-surface-900"
       [class.drag-over]="dragOver()"
       (drop)="onDrop($event)"
       (dragover)="onDragOver($event)"
       (dragleave)="onDragLeave($event)"
       (click)="$event.target === $event.currentTarget ? file.click() : null">
    @if (images().length === 0) {
      <div class="iu-empty text-gray-600 dark:text-gray-300">
        <p class="iu-empty-icon text-gray-400 dark:text-gray-500"><i class="pi pi-image"></i></p>
        <p class="iu-empty-text text-gray-700 dark:text-gray-200">Arrastra imágenes aquí o haz click para seleccionar.</p>
        <button type="button" class="iu-btn" (click)="file.click()" [disabled]="disabled || remaining()<=0">Seleccionar</button>
      </div>
    } @else {
      <div class="iu-grid">
        @for (img of images(); track img; let i = $index) {
          <div class="iu-item bg-gray-50 dark:bg-surface-900 border border-gray-200 dark:border-gray-700" (click)="open(i)">
            <img [src]="img.preview" [alt]="img.name" />
            <div class="iu-item-meta">
              <span class="iu-item-name text-gray-700 dark:text-gray-200" [title]="img.name">{{ img.name }}</span>
              <span class="iu-item-size text-gray-500 dark:text-gray-400">{{ bytesHuman(img.size) }}</span>
            </div>
            <button type="button" class="iu-remove dark:bg-slate-950/70 dark:hover:bg-slate-950/85" (click)="$event.stopPropagation(); remove(i)" title="Eliminar"><i class="pi pi-times"></i></button>
          </div>
        }
        @if (remaining()>0) {
          <button type="button" class="iu-add border-gray-300 dark:border-gray-600 bg-gray-50 dark:bg-surface-900 text-gray-700 dark:text-gray-200 hover:border-blue-400 dark:hover:border-blue-400" (click)="file.click()">
            <i class="pi pi-plus"></i>
            <span>Agregar</span>
          </button>
        }
      </div>
    }
  <input #file type="file" [attr.accept]="accept" multiple hidden (change)="onFileInput($event)" />
  </div>

  @if (errorMsg()) { <div class="iu-error bg-red-50 dark:bg-[#450a0a] border border-red-200 dark:border-[#7f1d1d] text-red-700 dark:text-red-200">{{ errorMsg() }}</div> }
  @if (images().length) {
    <div class="iu-footer text-gray-500 dark:text-gray-400">
      <p>Tip: click sobre la imagen para una vista completa.</p>
    </div>
  }
</div>

<!-- Viewer overlay via CDK Overlay -->
<ng-template #viewerTpl>
  <!-- Máscara propia: oscurece con transparencia y blur -->
  <div class="fixed inset-0 z-[5000] pointer-events-auto">
    <div class="absolute inset-0 bg-black/70 backdrop-blur-[1px]" (click)="closeViewer()"></div>

    <!-- Stage centrado -->
    <div class="relative h-full w-full flex items-center justify-center p-4" (click)="$event.stopPropagation()">
      <div class="iu-viewer-inner">
        <button type="button" class="iu-viewer-close bg-gray-900 hover:bg-gray-950" (click)="closeViewer()" title="Cerrar"><i class="pi pi-times"></i></button>
        <button type="button" class="iu-viewer-nav iu-viewer-prev bg-slate-950/85" (click)="prev()" title="Anterior"><i class="pi pi-chevron-left"></i></button>
        <div class="iu-image-stage" [class]="getSlideClass()">
          <img [src]="images()[viewerIndex()].preview" [alt]="images()[viewerIndex()].name" />
        </div>
        <button type="button" class="iu-viewer-nav iu-viewer-next bg-slate-950/85" (click)="next()" title="Siguiente"><i class="pi pi-chevron-right"></i></button>
        <div class="iu-viewer-caption bg-slate-900/75 text-gray-200">{{ images()[viewerIndex()].name }}</div>
      </div>
    </div>
  </div>
</ng-template>
